function resetField(name, {setFieldValue, setFieldTouched, setFieldError}, value = '') {
    setFieldValue(name, value, false);
    setFieldTouched(name, false, false);
    setFieldError(name);
}

export {resetField};